import React from 'react';
import {
  shouldUseRedesignForSurface,
  type UiReleaseMode,
  type UiReleaseSurface,
} from '../../config/uiRelease';
import BespokeLandingReleaseShell from './BespokeLandingReleaseShell';

interface PublicSpecialReleaseSurfaceProps {
  children: React.ReactNode;
  mode: UiReleaseMode;
  surface: Extract<UiReleaseSurface, 'pricing' | 'youtube'>;
}

/**
 * Applies the redesigned public-page chrome without replacing the page's
 * established content, pricing logic, or purchase actions. Legacy mode keeps
 * the original page tree byte-for-byte compatible.
 */
const PublicSpecialReleaseSurface: React.FC<PublicSpecialReleaseSurfaceProps> = ({ children, mode, surface }) => (
  shouldUseRedesignForSurface(mode, surface) ? (
    <BespokeLandingReleaseShell>{children}</BespokeLandingReleaseShell>
  ) : (
    <>{children}</>
  )
);

export default PublicSpecialReleaseSurface;
